import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { IonApp, setupIonicReact } from '@ionic/react';
import { IonReactHashRouter } from '@ionic/react-router';
import Home from './pages/home/Home';
import Backup from './pages/backup/Backup';
import Login from './pages/login/Login';
import DashboardPos from './pages/pos/DashboardPos';
import DashboardProducts from './pages/products/DashboardProducts';
import DashboardGastos from './pages/gasto/DashboardGastos';

import Dues from './pages/customer_dues/Dues';
import Rooms from './pages/rooms/Rooms';

import { createBrowserHistory } from 'history';
import { initdb } from "./data_base_local/dataservice";
import { getislogued } from './utils/functions';

import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';
import './theme/variables.css';
import Purchases from './pages/purchases/Purchases';
import RegisterReport from './pages/register_report/RegisterReport';
setupIonicReact();

const history = createBrowserHistory({ basename: '#' });

const App: React.FC = () => {
  initdb().catch(() => console.log("error sql"));
  return (
    <IonApp>
      <IonReactHashRouter history={history}>
        <Switch>
          <Route path="/login" render={(props: any) =>
            getislogued() ? <Redirect to="/home" /> : <Login {...props} />
          } exact={true} />

          <Route path="/home" render={(props: any) =>
            getislogued() ? <Home {...props} /> : <Redirect to="/login" />
          } exact={true} />

          <Route path="/dashboard_pos/:child" render={(props: any) =>
            getislogued() ? <DashboardPos {...props} /> : <Redirect to="/login" />
          } exact={true} />

          <Route path="/dashboard_products/:child" render={(props: any) =>
            getislogued() ? <DashboardProducts {...props} /> : <Redirect to="/login" />
          } exact={true} />

          <Route path="/" render={() =>
            getislogued() ? <Redirect to="/home" /> : <Redirect to="/login" />
          } exact={true} />

          <Route path="/backup" render={(props: any) =>
            getislogued() ? <Backup {...props} /> : <Redirect to="/login" />
          } exact={true} />

          <Route path="/customer_dues" render={(props: any) =>
            getislogued() ? <Dues {...props} /> : <Redirect to="/login" />
          } exact={true} />

          <Route path="/rooms" render={(props: any) =>
            getislogued() ? <Rooms {...props} /> : <Redirect to="/login" />
          } exact={true} />

          <Route path="/dashboard_gastos/:child" render={(props: any) =>
            getislogued() ? <DashboardGastos {...props} /> : <Redirect to="/login" />
          } exact={true} />

          <Route path="/purchases" render={(props: any) =>
            getislogued() ? <Purchases {...props} /> : <Redirect to="/login" />
          } exact={true} />

          <Route path="/cajas" render={(props: any) =>
            getislogued() ? <RegisterReport {...props} /> : <Redirect to="/login" />
          } exact={true} />

        </Switch>
      </IonReactHashRouter>
    </IonApp>
  );
};

export default App;